interface NumberStepperProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  label?: string;
  className?: string;
  disabled?: boolean;
}

export default function NumberStepper({
  value,
  onChange,
  min = 0,
  max = 1000,
  step = 1,
  label,
  className = "",
  disabled = false,
}: NumberStepperProps) {
  const handleIncrement = () => {
    const newValue = Math.min(max, value + step);
    onChange(newValue);
  };

  const handleDecrement = () => {
    const newValue = Math.max(min, value - step);
    onChange(newValue);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const parsed = parseInt(e.target.value);
    if (!isNaN(parsed)) {
      onChange(Math.min(max, Math.max(min, parsed)));
    }
  };

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {label && <label className="text-xs text-gray-600 mr-1">{label}</label>}
      <div className="flex items-center border rounded overflow-hidden">
        <button
          type="button"
          onClick={handleDecrement}
          disabled={disabled || value <= min}
          className="btn-custom px-2 py-1 bg-gray-100 hover:bg-gray-200 disabled:opacity-50 disabled:hover:bg-gray-100 text-gray-600 text-sm font-medium"
        >
          -
        </button>
        <input
          type="number"
          value={value}
          onChange={handleInputChange}
          disabled={disabled}
          min={min}
          max={max}
          className="w-14 px-1 py-1 text-sm text-center border-x focus:outline-none disabled:bg-gray-50"
        />
        <button
          type="button"
          onClick={handleIncrement}
          disabled={disabled || value >= max}
          className="btn-custom px-2 py-1 bg-gray-100 hover:bg-gray-200 disabled:opacity-50 disabled:hover:bg-gray-100 text-gray-600 text-sm font-medium"
        >
          +
        </button>
      </div>
    </div>
  );
}
